// extracted by mini-css-extract-plugin
module.exports = {"block":"Errors-module__block___2jZp_","input":"Errors-module__input___VFsym","message":"Errors-module__message___1hgw2","checkbox":"Errors-module__checkbox___3LocN"};